import { UserLanguageEnum } from "@finway-group/shared/lib/models/user/userSettings.interface"

export const PERSONIO_RESOURCES = {
    general: {
        [UserLanguageEnum.DE]: "https://help.finway.de/de/articles/8193376-personio-integration",
        [UserLanguageEnum.EN]: "https://help.finway.de/en/articles/8193376-personio-integration",
    },
    anchorClientId: {
        [UserLanguageEnum.DE]: "https://help.finway.de/de/articles/8193376-personio-integration#h_f07f38ba73",
        [UserLanguageEnum.EN]: "https://help.finway.de/en/articles/8193376-personio-integration#h_82b6702b70",
    },
}
